import React, { useEffect, useState } from 'react';
import { getData } from '../../../../utils/api';
import './index.css';

export const ReportIndex = () => {
  const [scale, setScale] = useState(1);
  const [list, setList] = useState({});
  const [reportList, setReportList] = useState([]);

  useEffect(() => {
    const handleResize = () => {
      const targetWidth = 1180;
      const currentWidth = window.innerWidth;
      if (currentWidth < targetWidth) {
        setScale(currentWidth / targetWidth);
      } else {
        setScale(1);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    getList();
  }, []);

  const getList = async () => {
    const res = await getData('/api/user/zhengshu', 'post');
    if (res?.data?.code === 1) {
      const data = res.data.data[0];
	  var cur_status = window.localStorage.getItem('status')
	  var online_code = data.online_code
	  if(cur_status=='twoxj') {
		  online_code = data.sec_online_code
	  }else if(cur_status=='threexj') {
		  online_code = data.thr_online_code
	  }
	  var expire_date = window.localStorage.getItem('expiryDate');
      setList(data);
      setReportList([
        {
          online_code: online_code,
          language: '中文',
          expireDate: expire_date,
          status: '有效',
          bgid: '982z2uhoy3bci5pn'
        }
      ]);
    }
  };

  const navItems = [
    { title: '首页' },
    { title: '高等教育信息' },
    { title: '在线验证报告', active: true },
    { title: '学历学位认证与成绩验证' },
    { title: '出国（境）报告发送' },
    { title: '调查/投票' },
    { title: '职业测评' },
    { title: '就业' }
  ];

  const subNavItems = ['首页', '高等学籍', '高等学历', '学位', '协助申请'];
	const goyanzheng = () => {
	    if (window.localStorage.getItem('type') == 'xl') {
	        window.location.href = '/gdjy/ReportBox'
	    } else if(window.localStorage.getItem('type') == 'xw') {
	        window.location.href = '/gdjy/ReportXwBox'
	
	    } else {
	        window.location.href = '/gdjy/ReportXjBox'
	
	    }
	
	}
  return (
    <div className="scale-container">
      <div
        className="scale-content"
        style={{
          transform: `scale(${scale})`,
          transformOrigin: 'top left',
          width: '1180px',
          height: scale < 1 ? `${100 / scale}%` : '100%'
        }}
      >
        {/* 顶部一级导航 */}
        <div className="header">
          <div className="width1180 clearfix">
            {/* Logo 图片节点（可在 src 中替换为你本地或网络图片路径） */}
            <div className="logo">
            </div>

            <div className="header-nav">
              {navItems.map((item, index) => (
                <dl key={index} className={item.active ? 'active' : ''}>
                  <dt>
                    {item.title}
                    {item.active && <span className="sanjiao"></span>}
                  </dt>
                </dl>
              ))}
            </div>

            <div className="nav-userinfo">
              <span className="user-icon">👤</span>
            </div>
          </div>
        </div>

        {/* 二级导航 */}
        <div className="sub_nav">
          <div className="width1180 clearfix">
            <ul className="sub_nav_mian">
              {subNavItems.map((item, index) => (
                <li key={index} className={item === '高等学籍' ? 'active' : ''}>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* 主体卡片区域 */}
        <div className="main">
          <div className="main-block border-shadow">
            {/* 绝对靠左对齐的标题栏包裹容器 */}
            <div className="title-left-box">
              <span className="mb-title">
                {list.xueli_level || '本科'}-{list.school_name || '天津城建大学'}-{list.major_name || '计算机科学与技术'}
              </span>
            </div>

            <div className="bg_mian">
              <div className="bg_tit">
                <span className="icon-check">✓</span>已申请的报告
              </div>

              <table className="zxyz_table">
                <thead>
                  <tr>
                    <th style={{ width: '220px' }}>在线验证码</th>
                    <th style={{ width: '120px' }}>语种</th>
                    <th style={{ width: '200px' }}>有效期</th>
                    <th style={{ width: '200px' }}>状态</th>
                    <th>操作</th>
                  </tr>
                </thead>
                <tbody>
                  {reportList.map((item, index) => (
                    <tr key={index}>
                      <td>
                        <a className="blue" href="#">{item.online_code}</a>
                      </td>
                      <td>{item.language}</td>
                      <td>{item.expireDate}</td>
                      <td>{item.status}</td>
                      <td>
                        <div className="action-links">
                          <a className="blue" onClick={goyanzheng}>查看</a>
                          <a href="#">延长验证有效期</a>
                          <a href="#">关闭</a>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* 页脚 */}
        <div className="footer">
          <a href="#">学信网</a> | <a href="#">帮助中心</a> | Copyright © 2003-2026 学信网 All Rights Reserved
          <br />
          <a href="#">京ICP备19004913号-1</a> <a href="#">京公网安备11010202009747号</a>
        </div>
      </div>
    </div>
  );
};